import React, { useEffect, useState } from "react";
import thankyou_page from "../assets/Images/thankyou_page.webp";
import Footer from "../layout/Footer.js";

export default function ThankYouPage() {
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {

    // ✅ Meta Lead Event Fire
    if (window.fbq) {
      window.fbq('track', 'Lead');
      console.log("✅ Meta Lead Event Fired");
    }

    console.log("Referrer URL:", document.referrer);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = document.referrer || "/";
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);

  }, []);

  return (
    <>
      <div style={styles.body}>
        <div className="container" style={styles.card}>
          <div className="col-12">
            {/* Image Card */}
            <div style={styles.imageWrapper}>
              <img
                src={thankyou_page}
                fetchpriority="high"
                alt="Main"
                style={styles.image}
              />
            </div>
          </div>

          {/* Checkmark Animation */}
          <svg
            className="checkmark"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
            style={styles.checkmark}
          >
            <circle
              className="checkmark__circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
              style={styles.checkmarkCircle}
            />
            <path
              className="checkmark__check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
              style={styles.checkmarkCheck}
            />
          </svg>

          <div style={styles.message}>Thank you for connecting with us!</div>
          <div style={styles.message1}>
            One of our representatives will be in touch shortly to help you with
            your inquiry.
          </div>
          <div style={styles.timer}>
            Redirecting to the previous page in <span>{countdown}</span> seconds...
          </div>

          <button
            style={styles.homeButton}
            onClick={() => (window.location.href = document.referrer || "/")}
          >
            Go Back to Previous Page
          </button>
        </div>
      </div>
      <Footer />
    </>

  );

}

/* Inline CSS styles */
const styles = {
  body: {
    height: "100vh",
    backgroundColor: "#f9f9f9",
    margin: 0,
    fontFamily: "Arial, sans-serif",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    minHeight: "80vh",
    textAlign: "center",
    padding: "30px",
    maxWidth: "700px", // card ki width limit
    margin: "0 auto",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // halka shadow
  },
  imageWrapper: {
    marginBottom: "20px",
  },
  image: {
    maxHeight: "200px",
    width: "auto",
    margin: "0 auto",
    display: "block",
    objectFit: "contain",
  },
  checkmark: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    display: "block",
    strokeWidth: 2,
    stroke: "white",
    strokeMiterlimit: 10,
    backgroundColor: "green",
    margin: "20px auto",
  },
  checkmarkCircle: {
    strokeDasharray: 166,
    strokeDashoffset: 166,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "green",
    fill: "none",
    animation: "stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards",
  },
  checkmarkCheck: {
    stroke: "white",
    transformOrigin: "50% 50%",
    strokeDasharray: 48,
    strokeDashoffset: 48,
    animation: "stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards",
  },
  message: {
    fontSize: "2rem",
    marginTop: "20px",
    color: "black",
  },
  message1: {
    fontSize: "1.25rem",
    marginTop: "10px",
    color: "black",
  },
  timer: {
    fontSize: "1.25rem",
    marginTop: "20px",
    color: "gray",
  },
  homeButton: {
    marginTop: "20px",
    padding: "10px 20px",
    fontSize: "1.2rem",
    color: "white",
    backgroundColor: "green",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};
